import { Touchpoint } from "../../../api/public/subscription-api";
import { Container, Service, TrackingEventNames, TrackingService } from "../../../symphony";
import { PaywallClickTypes, PaywallNavigationPage } from "../paywalls.constants";
import { PaywallsStore } from "../paywalls.store";

@Service()
export class PaywallsTrackingService {
  private trackingSerivce = Container.take('global', TrackingService);
  private store = Container.take('paywalls', PaywallsStore);

  public trackImpression = (
    webPageType?: 'PAYWALL' | 'CHECKOUT',
    touchpoint?: Touchpoint,
    paywallKey?: string,
    resolvedVariables?: any,
    orderNumber?: string
  ) => {
    // Use provided values or fall back to store values for backward compatibility
    const finalTouchpoint = touchpoint ?? this.store.currentTouchpoint.value;
    const paywallData = this.store.paywallData.value;
    const navigationData = this.store.paywallNavigation.value;

    const finalPaywallKey = paywallKey ?? paywallData.key;
    const finalResolvedVariables = resolvedVariables ?? paywallData.resolvedVariables;
    const finalOrderNumber = orderNumber ?? navigationData.step;
    const finalWebPageType = webPageType ?? (navigationData.page === PaywallNavigationPage.paywall ? 'PAYWALL' : 'CHECKOUT');

    this.trackingSerivce.tracking$.next({
      eventName: TrackingEventNames.paywallImpression,
      eventParams: {
        touchpoint: finalTouchpoint,
        webPageType: finalWebPageType,
        orderNumber: finalOrderNumber,
        resolvedVariables: finalResolvedVariables || {},
        paywallKey: finalPaywallKey,
        version: '3-0-0',
        appVersion: '0.0.0'
      },
      immediate: true
    });
  };

  public trackClick = (
    clickType: PaywallClickTypes,
    value?: string,
    webPageType?: 'PAYWALL' | 'CHECKOUT',
    touchpoint?: Touchpoint,
    paywallKey?: string,
    resolvedVariables?: any,
    orderNumber?: string
  ) => {
    // Use provided values or fall back to store values for backward compatibility
    const finalTouchpoint = touchpoint ?? this.store.currentTouchpoint.value;
    const paywallData = this.store.paywallData.value;
    const navigationData = this.store.paywallNavigation.value;

    const finalPaywallKey = paywallKey ?? paywallData.key;
    const finalResolvedVariables = resolvedVariables ?? paywallData.resolvedVariables;
    const finalOrderNumber = orderNumber ?? navigationData.step;
    const finalWebPageType = webPageType ?? (navigationData.page === PaywallNavigationPage.paywall ? 'PAYWALL' : 'CHECKOUT');

    this.trackingSerivce.tracking$.next({
      eventName: TrackingEventNames.paywallClick,
      eventParams: {
        value: value || null,
        touchpoint: finalTouchpoint,
        clickType,
        webPageType: finalWebPageType,
        orderNumber: finalOrderNumber,
        resolvedVariables: finalResolvedVariables || {},
        paywallKey: finalPaywallKey,
        version: '3-0-0',
        appVersion: '0.0.0'
      },
      immediate: true
    });
  };

  public trackSectionView = (section: string, sectionOrder: number) => {
    const touchpoint = this.store.currentTouchpoint.value;
    const { key, resolvedVariables } = this.store.paywallData.value;
    const { page, step } = this.store.paywallNavigation.value;
    this.trackingSerivce.tracking$.next({
      eventName: TrackingEventNames.paywallSectionView,
      eventParams: {
        touchpoint,
        webPageType: page === PaywallNavigationPage.paywall ? 'PAYWALL' : 'CHECKOUT',
        orderNumber: step,
        resolvedVariables: resolvedVariables || {},
        paywallKey: key,
        version: '1-0-0',
        appVersion: '0.0.0',
        section,
        sectionOrder: sectionOrder.toString()
      },
      immediate: true
    });
  };
}
